export const colors = {
  blackAlpha: {
    50: 'rgba(0, 0, 0, 0.04)',
    100: 'rgba(0, 0, 0, 0.06)',
    200: 'rgba(0, 0, 0, 0.08)',
    300: 'rgba(0, 0, 0, 0.16)',
    400: 'rgba(0, 0, 0, 0.24)',
    500: 'rgba(0, 0, 0, 0.36)',
    600: 'rgba(0, 0, 0, 0.48)',
    700: 'rgba(0, 0, 0, 0.64)',
    800: 'rgba(0, 0, 0, 0.80)',
    900: 'rgba(0, 0, 0, 0.92)',
  },
  whiteAlpha: {
    50: 'rgba(255, 255, 255, 0.04)',
    100: 'rgba(255, 255, 255, 0.06)',
    200: 'rgba(255, 255, 255, 0.08)',
    300: 'rgba(255, 255, 255, 0.16)',
    400: 'rgba(255, 255, 255, 0.24)',
    500: 'rgba(255, 255, 255, 0.36)',
    600: 'rgba(255, 255, 255, 0.48)',
    700: 'rgba(255, 255, 255, 0.64)',
    800: 'rgba(255, 255, 255, 0.80)',
    900: 'rgba(255, 255, 255, 0.92)',
  },
  gray: {
    50: '#f4f4f4',
    100: '#e0e0e0',
    200: '#c6c6c6',
    300: '#a8a8a8',
    400: '#76797f',
    500: '#343a45',
    600: '#22262c',
    650: '#1a1d21',
    700: '#121417',
    800: '#0b0c0d',
    900: '#000000',
  },
  corelight: {
    logo: '#00ab49',
    50: '#e6fcef',
    100: '#b0f6ce',
    200: '#8af2b7',
    300: '#54ec96',
    400: '#33e881',
    500: '#00e262',
    600: '#00a849',
    650: '#009441',
    700: '#00672d',
    800: '#00401c',
    900: '#001810',
  },
  blue: {
    50: '#edf5ff',
    100: '#b0b2cd',
    200: '#a6c8ff',
    300: '#78a9ff',
    400: '#4679bb',
    450: '#4381f5',
    500: '#0f62fe',
    600: '#0043ce',
    700: '#10328C',
    800: '#0b266d',
    900: '#081d54',
  },
  red: {
    50: '#fff1f1',
    100: '#ffd7d9',
    200: '#ffb3b8',
    300: '#ff8389',
    400: '#dc494b',
    500: '#da1e28',
    600: '#b50d0d',
    700: '#810909',
    800: '#640707',
    900: '#4c0505',
  },
  green: {
    50: '#e6fcef',
    100: '#b0f6ce',
    200: '#8af2b7',
    300: '#54ec96',
    400: '#33e881',
    500: '#00e262',
    600: '#00a849',
    650: '#009441',
    700: '#00672d',
    800: '#102a25',
    900: '#001810',
  },
  yellow: {
    50: '#fcf4d6',
    100: '#fddc69',
    200: '#f1c21b',
    300: '#d2a106',
    400: '#b28600',
    500: '#8e6a00',
    600: '#684e00',
    700: '#483700',
    800: '#302400',
    900: '#1c1500',
  },
  teal: {
    50: '#d9fbfb',
    100: '#9ef0f0',
    200: '#3ddbd9',
    300: '#30b0be',
    400: '#10909e',
    500: '#007d79',
    600: '#005d5d',
    700: '#102a25',
    800: '#032018',
    900: '#031d20',
  },
  orange: {
    50: '#fff2e8',
    100: '#ffd9be',
    200: '#ffb784',
    300: '#ff9300',
    400: '#f3720f',
    500: '#924409',
    600: '#8a3800',
    700: '#5e2900',
    800: '#3e1a00',
    900: '#1a0f00',
  },
  purple: {
    50: '#f6f2ff',
    100: '#e8daff',
    200: '#d4bbff',
    300: '#d26ae0',
    400: '#c94dda',
    500: '#bc21d1',
    600: '#851794',
    700: '#5e1069',
    800: '#490d51',
    900: '#330939',
  },
  pink: {
    50: '#fff0f7',
    100: '#ffd6e8',
    200: '#ffafd2',
    300: '#ff7eb6',
    400: '#dc4980',
    500: '#fb2176',
    600: '#842c4d',
    700: '#740937',
    800: '#510224',
    900: '#2a0a18',
  },
};
